import { render, staticRenderFns } from "./EmployeesEdit.vue?vue&type=template&id=d245e7b0"
import script from "./EmployeesEdit.vue?vue&type=script&lang=js"
export * from "./EmployeesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports